export const SET_EMAIL = 'SET_EMAIL';
export const RESET_EMAIL = 'RESET_EMAIL';
export const RESET_EMAIL_ERROR = 'RESET_EMAIL_EROR';

export const CHECK_EMAIL_REQUEST = 'CHECK_EMAIL_REQUEST';
export const CHECK_EMAIL_SUCCESS = 'CHECK_EMAIL_SUCCESS';
export const CHECK_EMAIL_FAILURE = 'CHECK_EMAIL_FAILURE';

export const CREATE_TOKEN_REQUEST = 'CREATE_TOKEN_REQUEST';
export const CREATE_TOKEN_SUCCESS = 'CREATE_TOKEN_SUCCESS';
export const CREATE_TOKEN_FAILURE = 'CREATE_TOKEN_FAILURE';

export const SET_TOKEN = 'SET_TOKEN';

export const CHECK_TOKEN_REQUEST = 'CHECK_TOKEN_REQUEST';
export const CHECK_TOKEN_SUCCESS = 'CHECK_TOKEN_SUCCESS';
export const CHECK_TOKEN_FAILURE = 'CHECK_TOKEN_FAILURE';

export const CHECK_PAIR_REQUEST = 'CHECK_PAIR_REQUEST';
export const CHECK_PAIR_SUCCESS = 'CHECK_PAIR_SUCCESS';
export const CHECK_PAIR_FAILURE = 'CHECK_PAIR_FAILURE';

export const SET_USER_DATA = 'SET_USER_DATA';
export const RESET_USER_DATA = 'RESET_USER_DATA';

export const PROCESS_USER_REQUEST = 'PROCESS_USER_REQUEST';
export const PROCESS_USER_SUCCESS = 'PROCESS_USER_SUCCESS';
export const PROCESS_USER_FAILURE = 'PROCESS_USER_FAILURE';

export const FORGOTTEN_PASS_SET_EMAIL = 'FORGOTTEN_PASS_SET_EMAIL';
export const FORGOTTEN_PASS_RESET_RESULTS = 'FORGOTTEN_PASS_RESET_RESULTS';

export const FORGOTTEN_PASS_CHECK_EMAIL_REQUEST = 'FORGOTTEN_PASS_CHECK_EMAIL_REQUEST';
export const FORGOTTEN_PASS_CHECK_EMAIL_SUCCESS = 'FORGOTTEN_PASS_CHECK_EMAIL_SUCCESS';
export const FORGOTTEN_PASS_CHECK_EMAIL_FAILURE = 'FORGOTTEN_PASS_CHECK_EMAIL_FAILURE';

export const FORGOTTEN_PASS_CHECK_TOKEN_REQUEST = 'FORGOTTEN_PASS_CHECK_TOKEN_REQUEST';
export const FORGOTTEN_PASS_CHECK_TOKEN_SUCCESS = 'FORGOTTEN_PASS_CHECK_TOKEN_SUCCESS';
export const FORGOTTEN_PASS_CHECK_TOKEN_FAILURE = 'FORGOTTEN_PASS_CHECK_TOKEN_FAILURE';

export const FORGOTTEN_PASS_NEW_PASS_REQUEST = 'FORGOTTEN_PASS_NEW_PASS_REQUEST';
export const FORGOTTEN_PASS_NEW_PASS_SUCCESS = 'FORGOTTEN_PASS_NEW_PASS_SUCCESS';
export const FORGOTTEN_PASS_NEW_PASS_FAILURE = 'FORGOTTEN_PASS_NEW_PASS_FAILURE';

export const CHANGE_PASS_SET_EMAIL = 'CHANGE_PASS_SET_EMAIL';
export const CHANGE_PASS_RESET_RESULTS = 'CHANGE_PASS_RESET_RESULTS';

export const CHANGE_PASS_CHECK_EMAIL_REQUEST = 'CHANGE_PASS_CHECK_EMAIL_REQUEST';
export const CHANGE_PASS_CHECK_EMAIL_SUCCESS = 'CHANGE_PASS_CHECK_EMAIL_SUCCESS';
export const CHANGE_PASS_CHECK_EMAIL_FAILURE = 'CHANGE_PASS_CHECK_EMAIL_FAILURE';

export const CHANGE_PASS_CHECK_TOKEN_REQUEST = 'CHANGE_PASS_CHECK_TOKEN_REQUEST';
export const CHANGE_PASS_CHECK_TOKEN_SUCCESS = 'CHANGE_PASS_CHECK_TOKEN_SUCCESS';
export const CHANGE_PASS_CHECK_TOKEN_FAILURE = 'CHANGE_PASS_CHECK_TOKEN_FAILURE';

export const CHANGE_PASS_NEW_PASS_REQUEST = 'CHANGE_PASS_NEW_PASS_REQUEST';
export const CHANGE_PASS_NEW_PASS_SUCCESS = 'CHANGE_PASS_NEW_PASS_SUCCESS';
export const CHANGE_PASS_NEW_PASS_FAILURE = 'CHANGE_PASS_NEW_PASS_FAILURE';
